import React, { useEffect, useState, useRef } from 'react';
import styles from './AdViseStep7.module.css';
import Slider from "react-slick";
import axios from 'axios'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import api from '../../../api';

const AdViseStep7 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {
    const [isImageAnalysing, setIsImageAnalysing] = useState(false);
    const [isLoadingConti, setIsLoadingConti] = useState(false);
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [contiImages, setContiImages] = useState([]);

    const settings1 = {
        infinite: false,
        speed: 200,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 100,
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex), // 슬라이드가 바뀌기 직전에 인디케이터 변경
    };

    const editConti = (key, value) => {
        setStepProps(prev => {
            const newProps = [...prev];
            // 기존 배열 복사
            const arr = [...newProps[7].conti];
            // 해당 요소만 업데이트
            arr[currentSlide] = {
                ...arr[currentSlide],
                [`${key}`]: value
            };
            newProps[7] = {
                ...newProps[7],
                conti: arr
            };
            return newProps;
        });
    };

    // contiIndex: 1 or 2, slide: 슬라이드 인덱스, tagIndex: 전체 tag_list 중 선택할 인덱스
    const toggleTag = (tagIndex) => {
        setStepProps(prev => {
            const newProps = [...prev];
            const arr = [...newProps[7].conti];
            const slideItem = { ...arr[currentSlide] };

            const allTags = slideItem.tag_list; 
            const fullTag = allTags[tagIndex];

            const selected = Array.isArray(slideItem.tags) ? [...slideItem.tags] : [];

            let newSelected;
            if (selected.includes(fullTag))
                newSelected = selected.filter(t => t !== fullTag);
            else if (selected.length < 2)
                newSelected = [...selected, fullTag];
            else
                newSelected = selected;
            

            slideItem.tags = newSelected;
            arr[currentSlide] = slideItem;
            newProps[7] = { ...newProps[7], conti: arr };
            return newProps;
        });
    };


    function haveSameElementsBySort(a = [], b = []) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
          return false;
        }
        // simple “every in a also in b” check:
        return a.every(
          ([ba, ia]) =>
            b.some(([bb, ib]) => ba === bb && ia === ib)
        );
    }

    function whenThisContiButtonClicked(index) {
        setAdViseStep(8);
    }

    const whenHomeButtonClicked = () => {
        const back = window.confirm("선택한 정보들이 모두 초기화돼요.\n\n정말 첫 화면으로 돌아갈까요?");
        if(back)
            setAdViseStep(0)
    };

    const getOriginalImages = () => stepProps[7].originalImages || [];

    const analysisImages = async () => {
        createConti();

        /*setIsImageAnalysing(true);
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[7] = {
                ...newProps[7],
                conti: null
            };
            return newProps;
        });
        try {
            const response = await axios.post(
                'https://hotple.today/win-api/api/analysis-images',
                {
                    place: stepProps[4].place,
                    instagramText: stepProps[3].hotple.media_caption,
                    images: getOriginalImages()
                }
            );

            if((response.data.result)){
                setStepProps(prev => {
                    const newProps = [...prev];
                    newProps[7] = {
                        ...newProps[7],
                        imageAnalysis: response.data.result,
                        selectedImages: stepProps[6].selectedImages,
                        placeId: stepProps[3].hotple.naver_map_place_id
                    };
                    return newProps;
                });
                setIsImageAnalysing(false);
                
                createConti(response.data.result);
            }
        } catch (error) {
            console.error('Error analysisImages:', error);
        } finally {
            setIsImageAnalysing(false);
        }*/
    }

    /*const createConti = async (images_context) => {
        setIsLoadingConti(true)

        try {
            const response = await axios.post(
                'https://hotple.today/win-api/api/create-conti',
                {
                    place: stepProps[4].place,
                    promotional_text: stepProps[4].placeAnalysis.promotional_text,
                    instagramText: stepProps[3].hotple.media_caption,
                    key_features: stepProps[4].placeAnalysis.key_features,
                    positive_summary: stepProps[4].reviewAnalysis.positive_summary.map(item => item.summary),
                    blogTexts: stepProps[4].blogTexts,
                    images_context: images_context,
                    thumbnail_index: stepProps[6].thumbnailIndex
                }
            );
            
            const [thumbBlogCursor, _] = stepProps[6].selectedImages[response.data.result.thumbnail.image_index];
            const thumbnailEntry = {
                image_index: response.data.result.thumbnail.image_index,
                isTitle: true,
                title: response.data.result.thumbnail.place_name,
                title_ori: response.data.result.thumbnail.place_name,
                tags:response.data.result.thumbnail.tag_list.slice(0,2).map(tag => `#${tag}`),
                tag_list: response.data.result.thumbnail.tag_list.map(tag => `#${tag}`),
                desc: response.data.result.thumbnail.copywriting_list[0],
                copywriting_list: response.data.result.thumbnail.copywriting_list,
                caption: null,
                source: "blog",
                createBy: stepProps[4].blogReviews[thumbBlogCursor].authorId,
                category: stepProps[3].hotple.main_category,
                icon_keyword: response.data.result.thumbnail.icon_keyword
            };
            
            // conti 항목들도 caption이 null이 아닌 경우 배열로, null이면 빈 배열로 맞춤
            const contiEntries = response.data.result.conti.map(item => {
                const [b, i] = stepProps[6].selectedImages[item.image_index];
                return {
                    image_index: item.image_index,
                    isTitle: false,
                    caption: null,
                    caption_list: item.caption_list,
                    source: "blog",
                    createBy: stepProps[4].blogReviews[b].authorId,
                };
            });
            
            const fullConti = [thumbnailEntry, ...contiEntries];
            
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[7] = {
                    ...newProps[7],
                    conti: fullConti,
                };
                return newProps;
            });

            const selectedImageUrls = getOriginalImages();

            const matchedImages = fullConti.map(item => {
                const index = parseInt(item.image_index, 10);
                return selectedImageUrls[index];
            });

            setContiImages(matchedImages);
            sliderRef.current?.slickGoTo(0);
            setCurrentSlide(0);
        } catch (error) {
            console.error('Error createConti:', error);
        }

        setIsLoadingConti(false)
    }*/

    const createConti = async (recreate = false) => {
        setIsLoadingConti(true)

        let thumbnail = {};

        try {
            if(!stepProps[7].conti || (stepProps[7].conti && (stepProps[3].hotple.naver_map_place_id != stepProps[7].placeId)) || recreate){
                thumbnail = (
                    await axios.post('https://hotple.today/win-api/api/create-thumbnail', {
                        place: stepProps[4].place,
                        promotional_text: stepProps[4].placeAnalysis.promotional_text,
                        instagramText: stepProps[3].hotple.media_caption,
                        key_features: stepProps[4].placeAnalysis.key_features,
                        positive_summary: stepProps[4].reviewAnalysis.positive_summary.map(item => item.summary),
                        description: stepProps[4].placeAnalysis.description
                    })
                ).data.result.thumbnail;

            }
            else{
                thumbnail = {
                    place_name : stepProps[7].conti[0].title,
                    tag_list : stepProps[7].conti[0].tag_list.map(tag => tag.replace('#','')),
                    copywriting_list : stepProps[7].conti[0].copywriting_list,
                    icon_keyword : stepProps[7].conti[0].icon_keyword
                }
            }
            
            const thumbnailEntry = {
                image_index: stepProps[6].thumbnailIndex,
                isTitle: true,
                title: thumbnail.place_name,
                title_ori: thumbnail.place_name,
                tags:thumbnail.tag_list.slice(0,2).map(tag => `#${tag}`),
                tag_list: thumbnail.tag_list.map(tag => `#${tag}`),
                desc: thumbnail.copywriting_list[0],
                copywriting_list: thumbnail.copywriting_list,
                caption: null,
                source: stepProps[6].authorIds[stepProps[6].thumbnailIndex]=='업체등록사진' ? "naver" : "blog",
                createBy: stepProps[6].authorIds[stepProps[6].thumbnailIndex],
                category: stepProps[3].hotple.main_category,
                icon_keyword: thumbnail.icon_keyword
            };
            
            // conti 항목들도 caption이 null이 아닌 경우 배열로, null이면 빈 배열로 맞춤
            const contiEntries = stepProps[6].priorityIndex.map(idx => {
                return {
                    image_index: idx,
                    isTitle: false,
                    caption: null,
                    caption_list: [],
                    source: stepProps[6].authorIds[idx]=='업체등록사진' ? "naver" : "blog",
                    createBy: stepProps[6].authorIds[idx],
                };
            });
            
            const fullConti = [thumbnailEntry, ...contiEntries];
            
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[7] = {
                    ...newProps[7],
                    conti: fullConti,
                    placeId: stepProps[3].hotple.naver_map_place_id
                };
                return newProps;
            });

            const selectedImages = getOriginalImages();
            const matchedImages = fullConti.map(item => {
                const index = parseInt(item.image_index, 10);
                return selectedImages[index];
            });

            setContiImages(matchedImages);
            sliderRef.current?.slickGoTo(0);
            setCurrentSlide(0);
        } catch (error) {
            console.error('Error createConti:', error);
        }

        setIsLoadingConti(false)
    }

    function setImagesToScroll(){
        const selectedImages = getOriginalImages();
        const result = stepProps[7].conti;

        const matchedImages = result.map(item => {
            const index = parseInt(item.image_index, 10);
            return selectedImages[index];
        });

        setContiImages(matchedImages);
    }

    useEffect(()=>{
        if(stepProps[6].authorIds!=undefined){
            createConti();
        } else{
            setAdViseStep(20);
        }

        /*if((stepProps[3].hotple.naver_map_place_id != stepProps[6].placeId) || !haveSameElementsBySort(stepProps[6].selectedImages,stepProps[7].selectedImages)){
            analysisImages();
        }
        else {
            if(stepProps[7].imageAnalysis.length!=0){
                if(!stepProps[7].conti || (stepProps[7].conti && (stepProps[7].conti[0].image_index != stepProps[6].thumbnailIndex)))
                    createConti(stepProps[7].imageAnalysis);
                else
                    setImagesToScroll();
            }
            else
                analysisImages();
        }
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[8] = {
                ...newProps[8],
                pagePalettes:[],
                pages:[],
                result:[]
            };
            return newProps;
        });*/
    }, []);
    
    return (
        <div className={styles.outerframe}>
            <div className={styles.upperframe}>
                <img className={styles.backbuttonIcon} alt="" src="images/back_android.svg" onClick={()=>setAdViseStep(6)}/>
                <div className={styles.titleframe}>
                    <b className={styles.nextbuttontext}>STEP 7</b>
                    <div className={styles.stepdesc}>추천 콘티를 확인해주세요!</div>
                </div>
                <img className={styles.homebuttonIcon} alt="" src="images/home_outlined.svg" onClick={()=>whenHomeButtonClicked()}/>
            </div>
            <div className={styles.lowerframe} style={{height:`calc(100dvh - ${marginTop}px - 103px)`}}>
                {isImageAnalysing ?//stepProps[7].imageAnalysis.length==0 || isImageAnalysing ?
                    <div className={styles.loadingFrame}>
                        <div className={styles.loader}/>
                        <div className={styles.stepdesc}>이미지 분석 중...</div>
                    </div>
                :
                    <div className={styles.contentframe}>
                        {contiImages.length == 0 || isLoadingConti ?
                            <div className={styles.loadingFrame}>
                                <div className={styles.loader}/>
                                <div className={styles.stepdesc}>콘티 생성 중...</div>
                            </div>
                        :
                            <div className={styles.contiframe}>
                                <div className={styles.conticontentframe}>
                                    <div className={styles.pagebutton} onClick={() => sliderRef.current.slickPrev()}>
                                        <div className={styles.pagebuttontext}>◀</div>
                                    </div>
                                    <div className={styles.imageframe}>
                                        <Slider ref={sliderRef} {...settings1} className={styles.contiImage}>
                                            {contiImages.map(image => (
                                                <img 
                                                    className={styles.contiImage} 
                                                    alt="" 
                                                    src={`data:image/jpeg;base64,${image}`}
                                                />
                                            ))}
                                        </Slider>
                                        <div className={styles.captionframe}>
                                            <div className={styles.captiontext}>
                                                {stepProps[7].conti && (() => {
                                                const entry = stepProps[7].conti[currentSlide];
                                                return entry.isTitle ? (
                                                    <>
                                                    <p className={styles.p}>{entry.title}</p>
                                                    <p className={styles.p}>{entry.tags.join(' ')}</p>
                                                    <p className={styles.p}>{entry.desc}</p>
                                                    </>
                                                ) : (
                                                    <p className={styles.p}>{entry.caption}</p>
                                                );
                                                })()}
                                            </div>
                                        </div>
                                        <div className={styles.pageframe}>
                                            <div className={styles.pagetext}>{currentSlide+1} / {contiImages.length}</div>
                                        </div>
                                    </div>
                                    <div className={styles.pagebutton} onClick={() => sliderRef.current.slickNext()}>
                                        <div className={styles.pagebuttontext}>▶</div>
                                    </div>
                                </div>

                                { stepProps[7].conti &&
                                    (() => {
                                        const entry = stepProps[7].conti[currentSlide];
                                        if (!entry.isTitle || !Array.isArray(entry.tag_list)) return null;
                                        return (
                                            <>
                                                <div className={styles.text1}>[추천 태그]</div>
                                                <div className={styles.copywritingFrame}>
                                                {entry.tag_list.map((tag, idx) => {
                                                    const isSelected = entry.tags?.includes(tag);
                                                    return (
                                                        <div
                                                            key={idx}
                                                            className={
                                                            isSelected
                                                                ? styles.subcategory2Active
                                                                : styles.subcategory2
                                                            }
                                                            onClick={() =>
                                                            toggleTag(idx)
                                                            }
                                                        >
                                                            {tag}
                                                        </div>
                                                    );
                                                })}
                                                </div>
                                            </>
                                        );
                                    })()
                                }

                                {stepProps[7].conti && stepProps[7].conti[currentSlide].copywriting_list &&
                                    <>
                                        <div className={styles.text1}>[추천 카피라이팅]</div>
                                        <div className={styles.copywritingFrame}>
                                            {stepProps[7].conti[currentSlide].copywriting_list.map((copywriting)=>(
                                                <div
                                                    className={copywriting==stepProps[7].conti[currentSlide].desc?styles.subcategory2Active:styles.subcategory2}
                                                    onClick={()=>editConti('desc',  copywriting)}      
                                                >
                                                    {copywriting}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                }

                                {stepProps[7].conti && stepProps[7].conti[currentSlide].caption_list &&
                                <>
                                    <div className={styles.text1}>[추천 캡션]</div>
                                    <div className={styles.copywritingFrame}>
                                        <div
                                            className={stepProps[7].conti[currentSlide].caption==null?styles.subcategory2Active:styles.subcategory2}
                                            onClick={()=>editConti('caption',  null)}      
                                        >
                                            캡션 없음
                                        </div>
                                        {stepProps[7].conti[currentSlide].caption_list.map((caption)=>(
                                            <div
                                                className={caption==stepProps[7].conti[currentSlide].caption?styles.subcategory2Active:styles.subcategory2}
                                                onClick={()=>editConti('caption',  caption)}      
                                            >
                                                {caption}
                                            </div>
                                        ))}
                                    </div>
                                </>
                                }

                                <div className={styles.contibuttonframe}>
                                    <div className={styles.recreatebuttonframe} onClick={()=>createConti(true)}>
                                            <b className={styles.buttontext}>콘티 재생성 ↻</b>
                                    </div>
                                    <div className={styles.nextbuttonframe} onClick={()=>whenThisContiButtonClicked(1)}>
                                            <b className={styles.buttontext}>이 콘티로 할래요 →</b>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default AdViseStep7;